function smoothScroll (elScrollTop) {
  let num = document.documentElement.scrollTop || document.body.scrollTop
  const STEP = 5
  let step = STEP
  if (num > elScrollTop) {
    step = 0 - STEP
  }
  let timeId = setInterval(() => {
    if (Math.abs(elScrollTop - num) > STEP) {
      num += step
      window.scrollTo(0, num)
    } else {
      window.scrollTo(0, elScrollTop)
      clearInterval(timeId)
    }
  }, 1)
}

export function scrollPageByClass (className, option) {
  const el = document.querySelector('.' + className)
  if (option && typeof option === 'object') {
    let innerHeight = window.innerHeight
    const navHeight = 76
    let elY = el.offsetTop
    let pointY = elY + navHeight
    if (option.block === 'center') {
      pointY = elY - innerHeight / 2
    }
    if (option.block === 'end') {
      pointY = elY - innerHeight
    }
    smoothScroll(Math.floor(pointY))
  }
}

export function encodes (str) {
  str = str.toString()
  if (!str || str.length === 0) return ''
  var s = ''
  s = str.replace(/&amp;/g, '&')
  s = s.replace(/<(?=[^o][^)])/g, '&lt;')
  s = s.replace(/</g, '&lt;')
  s = s.replace(/>/g, '&gt;')
  // s = s.replace(/\"/g, '&#39;');
  // eslint-disable-next-line
  s = s.replace(/\"/g, '&quot;')
  s = s.replace(/\n/g, '<br>')
  return s
}
export function utf16toEntities (str) {
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g // 检测utf16字符正则
  str = str.replace(patt, function (char) {
    var H, L, code
    if (char.length === 2) {
      H = char.charCodeAt(0) // 取出高位
      L = char.charCodeAt(1) // 取出低位
      code = (H - 0xD800) * 0x400 + 0x10000 + L - 0xDC00 // 转换算法
      return '&#' + code + ';'
    } else {
      return char
    }
  })
  return str
}
export function uncodeUtf16 (str) {
  // eslint-disable-next-line
  var reg = /\&#.*?;/g
  var result = str.replace(reg, function (char) {
    var H, L, code
    if (char.length === 9) {
      code = parseInt(char.match(/[0-9]+/g))
      H = Math.floor((code - 0x10000) / 0x400) + 0xD800
      L = (code - 0x10000) % 0x400 + 0xDC00
      return unescape('%u' + H.toString(16) + '%u' + L.toString(16))
    } else {
      return char
    }
  })
  return result
}
